import * as React from "react";
import type { SVGProps } from "react";
const SvgMap02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m2.361 4.8 16.705 16.87M2.36 4.8a3.38 3.38 0 0 1 2.587-1.2h5.647M2.361 4.8c-.5.59-.801 1.354-.801 2.188v12.424A3.39 3.39 0 0 0 4.948 22.8h12.424a3.39 3.39 0 0 0 3.388-3.388v-5.083m-10.165 0-7.34 7.342M18.6 5.04v-.072m3.84-.011c0 2.504-3.84 5.843-3.84 5.843s-3.84-3.34-3.84-5.843c0-2.075 1.72-3.757 3.84-3.757s3.84 1.682 3.84 3.757"
    />
  </svg>
);
export default SvgMap02;
